import { render, staticRenderFns } from "./ActivitiesReport.vue?vue&type=template&id=c4311130"
import script from "./ActivitiesReport.vue?vue&type=script&lang=js"
export * from "./ActivitiesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports